export const STORAGE_KEYS = {
  AUTH_USER: 'auth_user',
  TIMER_STATE: 'timer-state',
  AUTH_STORAGE: 'auth-storage',
} as const
